import React from 'react';
import './Layout.css';

const Layout = ({ children, isHomePage = false }) => {
  return (
    <div className={`page-content ${isHomePage ? 'home-page' : ''}`}>
      {children}
    </div>
  );
};

export default Layout;